module.exports = __webpack_public_path__ + "img/organizations.2e55f881.svg";